var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "heart (1) 1",
    clipPath: "url(#clip0_338_48277)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18 33.5678C17.8179 33.5678 17.6359 33.5208 17.4727 33.4266C17.2955 33.3244 13.0859 30.8802 8.8158 27.1973C6.28498 25.0146 4.26477 22.8497 2.81141 20.7628C0.930696 18.0624 -0.0150761 15.4649 0.000181693 13.0425C0.018041 10.2236 1.02766 7.57273 2.84326 5.57797C4.68952 3.5496 7.15341 2.43262 9.78119 2.43262C13.1489 2.43262 16.228 4.3191 18.0001 7.30751C19.7722 4.31917 22.8512 2.43262 26.219 2.43262C28.7015 2.43262 31.0702 3.44047 32.8887 5.27056C34.8845 7.2789 36.0184 10.1166 35.9998 13.0558C35.9845 15.4741 35.021 18.0676 33.1361 20.7643C31.6783 22.8501 29.6609 25.0141 27.14 27.1961C22.8855 30.8786 18.7061 33.3227 18.5302 33.425C18.3663 33.5202 18.1831 33.5678 18 33.5678Z",
    fill: "#2EBB49"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_338_48277"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYes);
export default __webpack_public_path__ + "static/media/yes.fdf78f925887def52a871571831b1de9.svg";
export { ForwardRef as ReactComponent };